import React, { usestate } from "react";
import { Box, Typography } from "@mui/material";
import VideoComoponent from "./VideoComoponent";
import OptionMenue from "../OptionMenue";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const GoalVideoComponent = ({ data, filterState, deleteTournamentFunc }) => {
  // const [voteState, setVoteState] = useState();
  const navigate = useNavigate();
  // "";
  const userData = useSelector((state) => state.user);
  // "";
  const isAdmin = data.user_id == userData.data.id;
  return (
    <>
      <Box className="goal-video-outter" style={{ paddingLeft: "30px" }}>
        <Box className="goal-video-wrapper">
          <Box className="video-wrapper ">
            <VideoComoponent img={data?.league_logo} data={data} />
          </Box>
          <Box
            className="goal-info-wrapper"
            onClick={() => navigate(`/viewLeague/${data?.id}`)}
            sx={{ cursor: "pointer" }}
          >
            <Typography component="h3">{data?.title}</Typography>
            <Box className="votes-wrapper">
              <Typography component="p">
                {data?.goalVideoCount + " "}
                Videos
              </Typography>
            </Box>
          </Box>
          <Box className="more-options">
            <OptionMenue
              data={data}
              filterState={filterState}
              deleteFunc={deleteTournamentFunc}
              isAdmin={isAdmin}
            />
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default GoalVideoComponent;
